export const DEFAULT_DROPDOWN_WIDTH = 300;

export const UNGROUPED_KEY = 'Ungrouped';
